//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

export default function MyPageProduct(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate(`/product/detail/` + props.i);
    };

    return (
        <>
            {props.simple ? (
                <DivListBox className="워메 미치겠네~~~~~~ 이건원래 div 여썸">
                    <ImgWrap
                        onClick={() => {
                            goDetailPage();
                        }}
                    >
                        <Img src={props.productImg} alt={props.itemName} />
                    </ImgWrap>
                    <TextWrap>
                        <TopWrap>
                            <Name
                                thinText={props.thinText}
                                onClick={() => {
                                    goDetailPage();
                                }}
                            >
                                {props.itemName}
                            </Name>
                        </TopWrap>

                        <OptionWrap>
                            <Option>
                                <span>{props.option}</span>
                            </Option>
                        </OptionWrap>
                    </TextWrap>
                </DivListBox>
            ) : (
                <ListBox className="워메 미치겠네~~~~~~">
                    <ImgWrap
                        onClick={() => {
                            goDetailPage();
                        }}
                    >
                        <Img src={props.productImg} alt={props.itemName} />
                    </ImgWrap>
                    <TextWrap>
                        <TopWrap>
                            <Name
                                onClick={() => {
                                    goDetailPage();
                                }}
                            >
                                {props.itemName}
                            </Name>
                        </TopWrap>

                        <OptionWrap>
                            <Option>
                                옵션 : <span>{props.option}</span>
                            </Option>
                        </OptionWrap>

                        <PriceWrap>
                            <Price>{props.price}원 / </Price>
                            <Num>수량 {props.num}개</Num>
                        </PriceWrap>
                    </TextWrap>
                </ListBox>
            )}
        </>
    );
}

const ListBox = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (465 / 1920));

    /* padding-right: calc(100vw * (10 / 1920)); */

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (465 / 1300));

        /* padding-right: calc(100vw * (10 / 1300)); */
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        /* padding-right: 0; */
    }
`;
const DivListBox = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (465 / 1920));

    padding-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (465 / 1300));

        padding-right: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(465)};
        padding-right: 0;
    }
`;
const ImgWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (80 / 1920));
    height: calc(100vw * (80 / 1920));

    margin-right: calc(100vw * (18 / 1920));
    /* margin-bottom: calc(100vw * (9 / 1920)); */

    cursor: pointer;

    border-radius: 4px;
    border: solid 1px #ddd;
    background-color: #fafafa;

    overflow: hidden;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (80 / 1300));
        height: calc(100vw * (80 / 1300));

        margin-right: calc(100vw * (18 / 1300));
        /* margin-bottom: calc(100vw * (9 / 1300)); */

        overflow: hidden;
    }

    @media screen and (max-width: 900px) {
        width: ${M(80)};
        height: ${M(80)};
        margin-right: ${M(18)};
        /* margin-bottom: 0; */
        /* margin-bottom: ${M(9)}; */

        overflow: hidden;
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const TextWrap = styled.div`
    width: calc(100% - 100vw * (98 / 1920));
    /* 
    ${({ bigImg }) => {
        return (
            bigImg &&
            `
                width: calc( 100% - 100vw * (145/ 1920));
            `
        );
    }} */

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (98 / 1300));

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
                 width: calc( 100% - 100vw * (145/ 1300));
                `
            );
        }} */
    }

    @media screen and (max-width: 900px) {
        /* width: 100% - 100vw * ${M(465)}; */

        /* ${({ bigImg }) => {
            return (
                bigImg &&
                `
                    // width: calc( 100% - 100vw * (145/ 1920));
                `
            );
        }} */
    }
`;

const TopWrap = styled.div`
    display: flex;
    align-items: center;

    padding-right: calc(100vw * (1 / 1920));

    @media screen and (max-width: 1300px) {
        padding-right: calc(100vw * (1 / 1300));
    }
`;

const Name = styled.h3`
    font-family: "Pop-EB";
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (6 / 1920));

    /* 한줄처리 */
    max-width: calc(100% - calc(100vw * (20 / 1920)));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-right: auto;
    cursor: pointer;

    ${({ thinText }) => {
        return (
            thinText &&
            `
            font-family: 'Pop-M';
        `
        );
    }}

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (6 / 1300));

        /* 한줄처리 */
        max-width: calc(100% - calc(100vw * (20 / 1300)));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        margin-bottom: ${M(6)};
        max-width: ${M(90)};
    }
`;
const OptionWrap = styled.div`
    & p {
        text-align: left;
    }
`;
const Option = styled.p`
    font-size: calc(100vw * (13 / 1920));

    color: #aaaaaa;

    & span {
        color: #aaaaaa;
        font-family: "Pop-M";
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const PriceWrap = styled.div`
    text-align: left;

    @media screen and (max-width: 900px) {
        margin-top: ${M(5)};
    }
`;
const Price = styled.span`
    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const Num = styled.span`
    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
